module.exports = __webpack_public_path__ + "static/media/france.4a6c0f70.jpg";